import {
  DataPageLimit,
  DataQueryParamModuleName,
  DataQueryParamFrom,
  DataQueryParamTo,
  DataModuleEntity,
} from '@edgvr-front/data/domain';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getSelectors } from '@ngrx/router-store';
import {
  DATA_MODULES_FEATURE_KEY,
  DataModulesState,
  dataModulesAdapter,
} from '../reducers';

const dataModulesState = createFeatureSelector<DataModulesState>(
  DATA_MODULES_FEATURE_KEY
);

const { selectAll } = dataModulesAdapter.getSelectors();
const { selectQueryParams } = getSelectors();

export const dataModules = createSelector(
  dataModulesState,
  (state: DataModulesState) =>
    selectAll(state).map((_) => DataModuleEntity.factory(_))
);

export const selectedDataModule = createSelector(
  dataModulesState,
  (state: DataModulesState) => {
    const selectedDataModule = state.selectedDataModuleId
      ? state.entities[state.selectedDataModuleId]
      : null;

    return selectedDataModule
      ? DataModuleEntity.factory(selectedDataModule)
      : null;
  }
);

export const count = createSelector(
  dataModulesState,
  (state: DataModulesState) => state.count
);
export const from = createSelector(
  dataModulesState,
  (state: DataModulesState) => (state.page - 1) * DataPageLimit
);
export const to = createSelector(
  dataModulesState,
  (state: DataModulesState) => state.page * DataPageLimit
);

export const page = createSelector(
  dataModulesState,
  (state: DataModulesState) => state.page
);
export const prevPage = createSelector(
  dataModulesState,
  (state: DataModulesState) => (state.page > 1 ? state.page - 1 : 0)
);
export const nextPage = createSelector(
  dataModulesState,
  (state: DataModulesState) =>
    state.page * DataPageLimit < state.count ? state.page + 1 : 0
);

export const loading = createSelector(
  dataModulesState,
  (state: DataModulesState) => state.loading
);

export const loaded = createSelector(
  dataModulesState,
  (state: DataModulesState) => state.loaded
);

export const routerModuleName = createSelector(
  selectQueryParams,
  (queryParams) => queryParams[DataQueryParamModuleName]
);
export const routerFrom = createSelector(
  selectQueryParams,
  (queryParams) => queryParams[DataQueryParamFrom]
);
export const routerTo = createSelector(
  selectQueryParams,
  (queryParams) => queryParams[DataQueryParamTo]
);
